/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/surveys" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdSurveys } from "./constants";
import type { EngagementAppGroupIdSurveysParams, GetEngagementAppGroupIdSurveysResult } from "./types";
import { isGetEngagementAppGroupIdSurveysResult } from "./validators";

export const getDataTableEngagementAppGroupIdSurveys = reactQueryTableFetcherAdapter(
  engagementAppGroupIdSurveys,
  (
    signal: AbortSignal,
    { appGroupId, query = {}, groupby, limit = 20, start = 0, sortdir, sortby }: EngagementAppGroupIdSurveysParams
  ): Promise<GetEngagementAppGroupIdSurveysResult> => {
    return fetch(
      `/engagement/${appGroupId}/surveys`,
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        query: serializeQueryObjects(query),
      },
      { signal }
    );
  },
  isGetEngagementAppGroupIdSurveysResult
);
